import React from 'react';
import {connect} from 'react-redux'
import {Redirect, Route, Switch} from 'react-router-dom';
import {userSignOut} from 'actions/Auth';
import IntlMessages from 'util/IntlMessages';

class UserInfoPopup extends React.Component {
    handleLogout = () => {
        this.props.userSignOut()
        return ( <Redirect to={'/signin'}/> )
    }
    render() {
        return (
            <div>
                <div className="user-profile">
                    <img className="user-avatar border-0 size-40 rounded-circle"
                         src="https://via.placeholder.com/150x150"
                         alt="User"/>
                    <div className="user-detail ml-2">
                        <h4 className="user-name mb-0">Chris Harris</h4>
                        <small>Administrator</small>
                    </div>
                </div>
                <a className="dropdown-item text-muted" href="javascript:void(0)">
                    <i className="zmdi zmdi-face zmdi-hc-fw mr-1"/>
                    <IntlMessages id="popup.profile"/>
                </a>
                <a className="dropdown-item text-muted" href="javascript:void(0)">
                    <i className="zmdi zmdi-settings zmdi-hc-fw mr-1"/>
                    <IntlMessages id="popup.setting"/>
                </a>
                <a className="dropdown-item text-muted" href="javascript:void(0)" onClick={this.handleLogout}>
                    <i className="zmdi zmdi-sign-in zmdi-hc-fw mr-1"/>
                    <IntlMessages id="popup.logout"/>
                </a>
            </div>
        );
    }
}

export default connect(null, {userSignOut})(UserInfoPopup);





// WEBPACK FOOTER //
// ./components/UserInfo/UserInfoPopup.js